import axios from ".";

/** List objectives filtered by status/year. */
export const getAllObjectives = (params?: any) => {
  return axios({
    method: "POST",
    url: "/objective",
    params: {
      year: params.year ? params.year : undefined,
    },
    data: {
      status: params.status ? params.status : null,
      departments: params.departments ? params.departments : null,
    },
  });
};

/** Get objective by id. */
export const getObjectivesById = (params?: any) => {
  return axios({
    method: "GET",
    url: `/objective/${params.objectId}`,
  });
};

/** Create a new objective. */
export const addObjective = (data?: any) => {
  return axios({
    method: "POST",
    url: `/objective/create-objective`,
    data: data,
  });
};
/** List all employees. */
export const getAllEmployee = () => {
  return axios({
    method: "GET",
    url: `/employees`,
  });
};
/** Update objective by id. */
export const updateObjective = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/objective/${id}`,
    data: data,
  });
};
/** Create a key result. */
export const addKeyresult = (data?: any) => {
  return axios({
    method: "POST",
    url: `/key-results/create-keyResult`,
    data: data,
  });
};
/** Update a key result by id. */
export const editKeyresult = (id: any, data?: any) => {
  return axios({
    method: "PUT",
    url: `/key-results/${id}`,
    data: data,
  });
};
/** Create a related initiative. */
export const addInitiative = (data?: any) => {
  return axios({
    method: "POST",
    url: `/initiative/create-initiative`,
    data: data,
  });
};

/** Delete a key result by id. */
export const deleteKeyResult = (id: number | null) => {
  return axios({
    method: "DELETE",
    url: `/key-results/${id}`,
  });
};
